module.exports = __webpack_public_path__ + "img/logo-light.e1c822b6.png";